module.exports = "dist/images/components-design-separator-control-wave-3.6db0486.png";